/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Retake_Note_FrontInputs */

const en_us2_body_assessment_retake_note_front = /** @type {(inputs: Body_Assessment_Retake_Note_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only the front photo needs retaking. The side one still counts.`)
};

const pt_br2_body_assessment_retake_note_front = /** @type {(inputs: Body_Assessment_Retake_Note_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só a foto de frente precisa ser refeita. A de lado continua valendo.`)
};

const es_419_body_assessment_retake_note_front = /** @type {(inputs: Body_Assessment_Retake_Note_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo hay que volver a tomar la foto de frente. La de lado sigue valiendo.`)
};

const pt_pt2_body_assessment_retake_note_front = /** @type {(inputs: Body_Assessment_Retake_Note_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só a foto de frente precisa de ser repetida. A de lado continua a valer.`)
};

const fr_fr2_body_assessment_retake_note_front = /** @type {(inputs: Body_Assessment_Retake_Note_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seule la photo de face est à reprendre. Celle de profil reste valable.`)
};

const de_de2_body_assessment_retake_note_front = /** @type {(inputs: Body_Assessment_Retake_Note_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur das Frontfoto muss neu. Das Seitenfoto zählt weiter.`)
};

const it_it2_body_assessment_retake_note_front = /** @type {(inputs: Body_Assessment_Retake_Note_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Va rifatta solo la foto frontale. Quella laterale resta valida.`)
};

/**
* | output |
* | --- |
* | "Only the front photo needs retaking. The side one still counts." |
*
* @param {Body_Assessment_Retake_Note_FrontInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_retake_note_front = /** @type {((inputs?: Body_Assessment_Retake_Note_FrontInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Retake_Note_FrontInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_retake_note_front(inputs)
	if (locale === "es-419") return es_419_body_assessment_retake_note_front(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_retake_note_front(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_retake_note_front(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_retake_note_front(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_retake_note_front(inputs)
	return en_us2_body_assessment_retake_note_front(inputs)
});
export { body_assessment_retake_note_front as "body-assessment.retake_note_front" }